import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

const LoginPage = () => {
  const { t, login } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <h1 className="font-serif text-4xl text-slate-900 mb-2">{t.auth.loginTitle}</h1>
      <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500 mb-8">/ access your scenarios</div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500 mb-2">{t.auth.email}</div>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full bg-white border border-slate-300 px-3 py-2.5 text-sm font-mono focus:border-slate-900" />
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500 mb-2">{t.auth.password}</div>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full bg-white border border-slate-300 px-3 py-2.5 text-sm font-mono focus:border-slate-900" />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full px-6 py-3.5 bg-slate-900 text-white text-xs font-mono uppercase tracking-[0.2em] hover:bg-slate-800 disabled:opacity-50">
          {loading ? "…" : t.auth.submit}
        </button>
      </form>

      <Link to="/register" data-testid="goto-register"
        className="block mt-6 text-xs font-mono uppercase tracking-[0.15em] text-blue-700 hover:underline">
        {t.auth.switchToRegister}
      </Link>
    </section>
  );
};

export default LoginPage;
